import { CalculatedField } from "./types/skyward/reporting";

window.skyward.base.registerScript('reportingCalculatedFields', function (skyward, $)
{
    skyward.reporting = skyward.reporting || {};

    skyward.reporting.calculatedFields = (function ()
    {
        let originalValue = "";
        let CalculatedFields: { [id: string]: CalculatedField } = {};
        let dirtyLogicJsonPropertyOrder =
        {
            expression: null,
            id: null,
            module: null,
            object: null,
            fieldName: null,
            relationshipPath: null,
            dataType: null,
            parameters: null,
            schemaObject: null
        };

        const exposedMethods =
        {
            Get: function (id: string)
            {
                return CalculatedFields[id];
            },
            Set: function (calculatedField: CalculatedField)
            {
                // The $.extend is a concise way to ensure property names are in the correct order to detect dirty/changed data
                CalculatedFields[calculatedField.id] = $.extend({}, dirtyLogicJsonPropertyOrder, calculatedField);
            },
            Delete: function (id: string)
            {
                delete CalculatedFields[id];
            },
            Reset: function (calculatedFields: { [id: string]: CalculatedField })
            {
                CalculatedFields = $.extend({}, calculatedFields);
                originalValue = JSON.stringify(CalculatedFields);
            },
            AllFields: function ()
            {
                return $.extend({}, CalculatedFields);
            },
            AllFieldsOfType: function (fieldDataType: string)
            {
                let fieldsOfType: { [id: string]: CalculatedField } = {};
                $.each(exposedMethods.AllFields(), function ()
                {
                    const calculatedField = this;
                    if (calculatedField.dataType && calculatedField.dataType.indexOf(fieldDataType) === 0)
                    {
                        fieldsOfType[calculatedField.id] = calculatedField;
                    }
                });
                return fieldsOfType;
            },
            AllFieldsOfModuleAndObject: function (rootModule: string, rootObject: string, relationshipPath: string)
            {
                let fields: { [id: string]: CalculatedField } = {};
                let schemaObject = rootModule + '.' + rootObject;
                $.each(exposedMethods.AllFields(), function ()
                {
                    const calculatedField = this;

                    if (calculatedField.schemaObject === schemaObject && (calculatedField.relationshipPath ?? "") === (relationshipPath ?? ""))
                    {
                        fields[calculatedField.id] = calculatedField;
                    }
                });
                return fields;
            },
            IsDirty: function ()
            {
                return (originalValue != JSON.stringify(CalculatedFields));
            },
            NameExists: function (name: string)
            {
                name = (name || "").toLowerCase();
                let nameExists = false;
                $.each(CalculatedFields, function ()
                {
                    if (this.fieldName.toLowerCase() == name)
                    {
                        nameExists = true;
                        return false;
                    }
                });
                return nameExists;
            },
            Parameters: function ()
            {
                let parameters: any[] = [];

                $.each(exposedMethods.AllFields(), function ()
                {
                    $.each(this.parameters, function ()
                    {
                        parameters.push(this);
                    });
                });
                return parameters;
            },
            ConvertBindingsToFriendlyNames: function (data: string)
            {
                if (typeof data !== "string")
                {
                    return "";
                }

                let result = data;
                for (let id in CalculatedFields)
                {
                    result = result.split("{" + id + "}").join("{C:" + CalculatedFields[id].fieldName + "}");
                }
                return result;
            },
            ConvertFriendlyNamesToBindings: function (data: string)
            {
                if (typeof data !== "string")
                {
                    return "";
                }

                let result = data;
                for (let id in CalculatedFields)
                {
                    result = result.split("{C:" + CalculatedFields[id].fieldName + "}").join("{" + id + "}");
                }
                return result;
            }
        };

        return exposedMethods;
    })();
});